<template>
    <el-radio-group v-model="radio" size="mini" @input="radioChange">
      <el-tooltip :content="$t('cswcvs1')" placement="top-end" effect="light">
        <el-radio-button label="1x1">
          <div class="split-1 split"></div>
          </el-radio-button>
      </el-tooltip>
      <el-tooltip :content="$t('cswcvs2')" placement="top-end" effect="light">
        <el-radio-button label="1x2">        
          <div class="split-2 split">
              <div></div>
          </div>
        </el-radio-button>
      </el-tooltip>
      <el-tooltip :content="$t('cswcvs3')" placement="top-end" effect="light">
        <el-radio-button label="1x3">        
          <div class="split-3 split">
              <div></div>
              <div></div>
          </div>
        </el-radio-button>
      </el-tooltip>
      <el-tooltip :content="$t('cswcvs4')" placement="top-end" effect="light">
        <el-radio-button label="2x2">
          <div class="split-4 split">
              <div class="left"></div>
              <div class="right"></div>
          </div>
        </el-radio-button>
      </el-tooltip>
      <el-tooltip :content="$t('cswcvs5')" placement="top-end" effect="light">
        <el-radio-button label="MxN" v-popover:popover @click.native="selfTrans">
          <div class="split-MN split">
            <div>MxN</div>
          </div>
        </el-radio-button>
      </el-tooltip>
      <el-popover
        ref="popover"
        placement="bottom"
        width="300"
        v-model="visible">
        <div class="split-choose">
          <el-input-number size="small" v-model="num1" controls-position="right" :min="1" :max="10"
          style="width: 80px"></el-input-number>x
          <el-input-number size="small" v-model="num2" controls-position="right" :min="1" :max="10"
          style="width: 80px"></el-input-number>
          <el-button size="small" type="info" @click="cancel">{{$t('cswcvs6')}}</el-button>
          <el-button type="primary" size="small" @click="confirm">{{$t('cswcvs7')}}</el-button>
        </div>
        
      </el-popover>
    </el-radio-group>
      
</template>

<script>
export default {
    name: 'VdrSplit',
    inject: {
      vdrInfor: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        vdrw: 0,
        vdrh: 0,
        radio: '1x1',  //初始值
        num1: 1,  //自定义值
        num2: 3,
        recordNum1: 1,  //记录自定义值
        recordNum2: 3,
        visible: false,
        vLine: [],
        hLine: [],
        isConfirmed: false,
        borderValue: 5,  //屏幕内边框值
        // compensationValue: 0.5  //辅助线补偿值
      };
    },
    created() {
      this.vdrw = Number(this.vdrInfor.w);
      this.vdrh = Number(this.vdrInfor.h);
      this.setGrid(1, 1)
    },
    methods: {
      radioChange(){
        this.vLine = [];
        this.hLine = [];
        if(this.radio === 'MxN') {   //选中自定义网格
          this.visible = true;
          this.setGrid(this.num2, this.num1)
        }
        else {     //选中非自定义网格
          const v = this.radio.split('x')[1];
          const h = this.radio.split('x')[0];
          // console.log(v,h)
          this.setGrid(v, h)
        }
      },
      //点击开启或关闭自定义窗口
      selfTrans(e){
        if(e.target.tagName === 'INPUT'){
          this.visible = !this.visible;
        }
      },
      //关闭自定义窗口
      cancel(){
        this.visible = false;
      },
      //确认自定义的选择
      confirm(){
        this.vLine = [];
        this.hLine = [];
        this.visible = false;
        this.setGrid(this.num2, this.num1),
        this.isConfirmed = true
      },
      //处理数据
      setGrid(v, h) {
        const vPixel = this.vdrw / v;
        const hPixel = this.vdrh / h;
        for (let index = 0; index < v - 1; index++) {
          this.vLine.push({display: true, position: vPixel*(index+1), origin: 0, lineLength: this.vdrh})
        }
        for (let index = 0; index < h - 1; index++) {
          this.hLine.push({display: true, position: hPixel*(index+1), origin: 0, lineLength: this.vdrw})
        }
        this.handleData(this.scale)
      },
      //根据scale以及相应补偿处理数据
      handleData(scale) {
        const value = this.borderValue
        let vertical = JSON.parse(JSON.stringify(this.vLine));
        let horizon = JSON.parse(JSON.stringify(this.hLine));
        for (let index = 0; index < vertical.length; index++) {
          vertical[index].position = vertical[index].position * scale + value;
          vertical[index].origin = vertical[index].origin + value;
          vertical[index].lineLength = vertical[index].lineLength * scale
        }
        for (let index = 0; index < horizon.length; index++) {
          horizon[index].position = horizon[index].position * scale + value;
          horizon[index].origin = horizon[index].origin + value;
          horizon[index].lineLength = horizon[index].lineLength * scale
        }
        this.$store.commit("VDR_GRID_SET", [vertical, horizon]);  
      }
    },
    computed: {
      scale() {
        return Number(this.$store.state.program.ratio.toFixed(2));
      },
      grids() {
        return this.$store.state.program.grids
      }
    },
    watch: {
      scale: {
        handler(val) {
          // 页面大小调整时触发
          this.handleData(val)
        }
      },
      visible: {
        handler(val) {
          if(val === true) {
            this.isConfirmed = false;
            this.recordNum1 = this.num1;
            this.recordNum2 = this.num2;
          }
          if(val === false && this.isConfirmed === false) {
            this.num1 = this.recordNum1;
            this.num2 = this.recordNum2;
          }
        }
      }
    }
}
</script>

<style  lang="scss" scoped>
   /deep/ .el-radio-button--mini .el-radio-button__inner {
        padding: 5px 15px;
   }
   /deep/.el-button+.el-button {
    margin-left: 0;
    }
   .split {
          height: 15px;
          width: 30px;
          border: 1px solid;
          border-radius: 0;
   }
   .split-2 {
    div {
        height: 100%;
        width: 50%;
        box-sizing: border-box;
        border-right: 1px dashed;
    }
   }
   .split-3 {
      display: flex;
    div {
        height: 100%;
        width: 33%;
        box-sizing: border-box;
        border-right: 1px dashed;
    } 
    }
    .split-4 {
       position: relative;
       .left {
        width: 50%;
        height: 50%;
        position: absolute;
        top: 0;
        left: 0;
        border-right: 1px dashed;
        border-bottom: 1px dashed;
       } 
       .right {
        width: 50%;
        height: 50%;
        position: absolute;
        right: 0;
        bottom: 0;
        box-sizing: border-box;
        border-top: 1px dashed;
        border-left: 1px dashed;
       }
    }
    .split-MN {
      // height: 100%;
      // width: 100%;
        font-size: 8px;
        line-height: 15px;
    }

    .split-choose {
      display: flex;
      justify-content: space-around;
      align-items: baseline;
    }
   
</style>